<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-process-error-dialogue">
    <wy-dialogue ref="wyProcessErrorDialogue" :defaultTitle="defaultTitle">
      <div class="wy-process-error-dialogue-container">
        <div v-if="dialogueData.info && typeof dialogueData.info.message === 'string' ">
          {{dialogueData.info.message}}
          <hr>
        </div>
        <div v-else-if="dialogueData.info && Array.isArray(dialogueData.info.message)">
          <div v-for="(messageItem, index) in dialogueData.info.message" :key="index">
            <div><div class="wy-process-error-dialogue-header"><b>Process ID:</b><!-- //NOSONAR --></div> {{messageItem.processId}}</div>
            <div><div class="wy-process-error-dialogue-header"><b>Action:</b><!-- //NOSONAR --></div> {{messageItem.action}}</div>
            <div><div class="wy-process-error-dialogue-header"><b>Status:</b><!-- //NOSONAR --></div> {{messageItem.processStatus}}</div>
            <div><div class="wy-process-error-dialogue-header"><b>Action by:</b><!-- //NOSONAR --></div> {{messageItem.actionBy}}</div>
            <div><div class="wy-process-error-dialogue-header"><b>Start date:</b><!-- //NOSONAR --></div> {{messageItem.actionDate ? formatDate(messageItem.actionDate) : formatDate(messageItem.startDate)}}</div>
            <div v-if="messageItem.action == 'rename'">
              <div class="wy-process-error-dialogue-header"><b>Detail:</b><!-- //NOSONAR --></div> Rename from "{{messageItem.detail.topicDisplayName}}" to "{{messageItem.detail.topicDisplayNameNew}}"
            </div>
            <div v-else-if="messageItem.action == 'merge'">
              <div class="wy-process-error-dialogue-header"><b>Detail:</b><!-- //NOSONAR --></div> Merge "{{messageItem.detail.topicDisplayNamesToMerge.join('", "')}}" to "{{messageItem.detail.topicDisplayName}}"
            </div>
            <div v-else-if="messageItem.action == 'unmerge'">
              <div class="wy-process-error-dialogue-header"><b>Detail:</b><!-- //NOSONAR --></div> Unmerge "{{messageItem.detail.topicNames.join('", "')}}" from "{{messageItem.detail.topicDisplayName}}"
            </div>
            <div v-else-if="messageItem.action == 'blacklist'">
              <div class="wy-process-error-dialogue-header"><b>Detail:</b><!-- //NOSONAR --></div> Blacklist "{{messageItem.detail.topicDisplayNames.join('", "')}}"
            </div>
            <div v-else-if="messageItem.action == 'unblacklist'">
              <div class="wy-process-error-dialogue-header"><b>Detail:</b><!-- //NOSONAR --></div> Unblacklist "{{messageItem.detail.topicDisplayName}}"
            </div>
            <hr>
          </div>
        </div>        
        <div v-if="dialogueData.info && dialogueData.info.reload && dialogueData.controller.refreshData">
          Data may have been changed. Click <el-link type="primary" @click="refreshData">here</el-link> to refresh the data.
        </div>
      </div>
    </wy-dialogue>
  </div>
</template>

<script>
import Vue from 'vue';
import WyDialogue from '../components/widgets/wy-dialogue.vue';
import moment from 'moment';

export default Vue.extend({
  name: 'wy-process-error-dialogue',
  components: { 
    'wy-dialogue': WyDialogue
  },
  
  data() {
    return {
      dialogueData: {},
    }
  },

  computed: {
    defaultTitle()  {
      if(this.dialogueData.info && Array.isArray(this.dialogueData.info.message)) {
        return "Hmmm, below action is still in progress";
      }
      else {
        return "Oops! Something went wrong";
      }
    }
  },

  methods: {
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },

    showDialogue(dialogueData) {
      this.dialogueData = dialogueData;
      this.$refs.wyProcessErrorDialogue.show = true;
    },

    refreshData() {
      this.$refs.wyProcessErrorDialogue.show = false;
      if(this.dialogueData.controller.refreshData) {
        this.dialogueData.controller.refreshData()
      }
    }
  },

  created() {
    this.$root.$on("fire-page-events:processErrorDialogue", (data) => {
      this.showDialogue(data);
    });
  }
});
</script>

<style lang="scss">
.wy-process-error-dialogue {
  display: block;
  height: unset !important;
}

.wy-process-error-dialogue-container {
  line-height: 25px;
  margin-left: 41px;
  .wy-process-error-dialogue-header {
    display: inline-block;
    width: 87px;
    text-align: right;
  }
}
</style>